export const defaultBackgroundColor = 'bg-accent-60'